export default function PreLoader() {
    return (
        <div className="preloader">
            <div className="loader-p"></div>
        </div>
    )
}